import React from 'react'

// Components
import { Route, Switch } from 'react-router-dom'
import Loader from 'Components/Loader'

// Routes
const AccountEmailVerification = React.lazy(() => import('routes/AccountEmailVerification'))
const AddOffice365DataSource = React.lazy(() => import('routes/AddOffice365DataSource'))
const DropboxSignin = React.lazy(() => import('routes/DropboxSignin'))
const DropboxSigninAuth = React.lazy(() => import('routes/DropboxSignin/Auth'))
const EmailVerification = React.lazy(() => import('routes/EmailVerification'))
const ForgotPassword = React.lazy(() => import('routes/ForgotPassword'))
const Office365Signin = React.lazy(() => import('routes/Office365Signin'))
const Office365SigninAuth = React.lazy(() => import('routes/Office365Signin/Auth'))
const PasswordReset = React.lazy(() => import('routes/PasswordReset'))
const PrivateRoute = React.lazy(() => import('routes/PrivateRoute'))
const Signin = React.lazy(() => import('routes/Signin'))
const Signup = React.lazy(() => import('routes/Signup'))
const SignupFromInvite = React.lazy(() => import('routes/SignupFromInvite'))

const Routes = () => (
  <React.Suspense fallback={<Loader type="full" />}>
    <Switch>
      <Route path="/signin" name="Signin" render={(props) => <Signin {...props} />} />
      <Route exact path="/signup" name="Signup" render={(props) => <Signup {...props} />} />
      <Route
        path="/signup/managed"
        name="SignupFromInvite"
        render={(props) => <SignupFromInvite {...props} />}
      />
      <Route
        exact
        path="/dropbox"
        name="DropboxSignin"
        render={(props) => <DropboxSignin {...props} />}
      />
      <Route
        path="/verify"
        name="EmailVerification"
        render={(props) => <EmailVerification {...props} />}
      />
      <Route
        path="/password-reset"
        name="PasswordReset"
        render={(props) => <PasswordReset {...props} />}
      />
      <Route
        exact
        path="/office365"
        name="Office365Signin"
        render={(props) => <Office365Signin {...props} />}
      />
      <Route
        path="/dropbox/oauth2"
        name="DropboxSigninAuth"
        render={(props) => <DropboxSigninAuth {...props} />}
      />
      <Route
        exact
        path="/forgot-password"
        name="ForgotPassword"
        render={(props) => <ForgotPassword {...props} />}
      />
      <Route
        path="/office365/oauth2"
        name="Office365SigninAuth"
        render={(props) => <Office365SigninAuth {...props} />}
      />
      <Route
        path="/account/email/verification"
        name="AccountEmailVerification"
        render={(props) => <AccountEmailVerification {...props} />}
      />
      <Route
        path="/oauthsourceproviders/office365/oauth2"
        name="AddOffice365DataSource"
        render={(props) => <AddOffice365DataSource {...props} />}
      />
      <PrivateRoute />
    </Switch>
  </React.Suspense>
)

export default Routes
